import { getCurrency } from '../../services/tableHelper';
import { useSelector } from 'react-redux';

export default function OrderModalProductsList({ totalOrderPrice, orderVariants }: any) {
	const currency = useSelector((state: any) => getCurrency(state.auth.user.currency));

	return (
		<div style={{ marginBottom: '50px' }}>
			{orderVariants.length > 0 && (
				<div
					style={{
						display: 'grid',
						gridTemplateColumns: '3fr 1fr 1fr 1fr',
						gap: '10px',
						alignItems: 'center',
						marginBottom: '10px',
					}}
				>
					<div style={{ fontSize: '14px', paddingLeft: '10px' }}>Product</div>
					<div style={{ fontSize: '14px' }}>Unit Price</div>
					<div style={{ fontSize: '14px' }}>Qty</div>
					<div style={{ fontSize: '14px' }}>Total Price</div>
				</div>
			)}
			<div>
				{orderVariants &&
					orderVariants.map((variant: any) => {
						return (
							<div
								key={variant.id}
								style={{
									marginBottom: '5px',
									padding: '10px',
									display: 'grid',
									gridTemplateColumns: '3fr 1fr 1fr 1fr',
									gap: '10px',
									alignItems: 'center',
									borderTop: '1px solid #e5e7eb',
								}}
							>
								<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
									<h4 style={{ margin: '0px', fontSize: '15px', fontWeight: 'bold' }}>
										{variant.product.name}
									</h4>
									<h4 style={{ margin: '0px', fontSize: '13px', color: '#6b7280' }}>
										{variant.name} @ {currency}
										{Number(
											Number(variant.unit_price_at_purchase) -
												Number(variant.discount_amount || 0)
										).toFixed(2)}
									</h4>
									{variant.addons && variant.addons.length > 0 && (
										<div style={{ marginTop: '4px' }}>
											{variant.addons.map((addon: any, addonIndex: number) => (
												<div
													key={addonIndex}
													style={{
														fontSize: '12px',
														color: '#9ca3af',
														fontStyle: 'italic',
														marginTop: '2px',
													}}
												>
													+ {addon.name} (x{addon.quantity}) @ {currency}
													{Number(addon.unit_price_at_purchase).toFixed(2)}
												</div>
											))}
										</div>
									)}
								</div>
								<div style={{ fontSize: '14px' }}>
									{currency}{' '}
									{(() => {
										let unitPrice = Number(variant.unit_price_at_purchase);
										if (variant.addons && variant.addons.length > 0) {
											const addonTotal = variant.addons.reduce((sum: number, addon: any) => {
												return (
													sum + Number(addon.quantity) * Number(addon.unit_price_at_purchase)
												);
											}, 0);
											unitPrice += addonTotal;
										}
										return (unitPrice - variant.discount_amount).toFixed(2);
									})()}
								</div>
								<div style={{ fontSize: '14px', paddingLeft: '10px' }}>{variant.quantity}</div>
								<div style={{ fontSize: '14px' }}>
									{currency} {Number(variant.total_price).toFixed(2)}
								</div>
							</div>
						);
					})}
			</div>
			<div
				style={{
					padding: '10px',
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					marginTop: '10px',
					borderTop: '1px solid #e5e7eb',
				}}
			>
				<div>
					<h4 style={{ margin: '0px' }}>Total</h4>
				</div>
				<div>
					<span style={{ fontSize: '14px' }}>
						{currency} {totalOrderPrice?.toFixed(2)}
					</span>
				</div>
			</div>
		</div>
	);
}
